/* eslint-disable react/jsx-pascal-case */
/* Original name @uswitch/trustyle.link-list */

import * as React from 'react'
import { Themed } from 'theme-ui'
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon'

const VariantContext = React.createContext('base')

const styles = (variant, element) =>
  `elements.link-list.variants.${variant}${element ? `.${element}` : ''}`

export const LinkListTrustyle = ({
  children,
  title,
  icon,
  subtitle,
  subtitleUrl,
  variant = 'base',
  className,
}) => {
  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  const IconComponent = typeof icon === 'string' ? <DynamicSparkIcon glyph={icon} color='' /> : icon

  const titleProps = {
    as: 'h2',
    sx: {
      paddingTop: 'xs',
      paddingBottom: 'xs',
      margin: 0,
      variant: styles(variant, 'h3'),
    },
  }

  return (
    <VariantContext.Provider value={variant}>
      <div className={className} sx={{ variant: styles(variant) }}>
        <If condition={title || icon}>
          <section>
            <header
              sx={{
                display: 'flex',
                alignItems: 'center',
                variant: styles(variant, 'header'),
              }}
            >
              <If condition={variant === 'linkBlock'}>
                <div
                  sx={{
                    variant: styles(variant, 'icon'),
                  }}
                >
                  {IconComponent}
                </div>
              </If>
              <If condition={variant !== 'linkBlock'}>{IconComponent}</If>

              <If condition={title}>
                <React.Fragment>
                  <If condition={variant === 'linkBlock'}>
                    <Themed.h6 {...titleProps}>{title}</Themed.h6>
                  </If>

                  <If condition={variant !== 'linkBlock'}>
                    <Themed.h3 {...titleProps}>{title}</Themed.h3>
                  </If>
                </React.Fragment>
              </If>
            </header>

            <If condition={subtitle && subtitleUrl}>
              <LinkListTrustyleItem href={subtitleUrl}>
                <strong style={{ backgroundColor: 'unset' }}>{subtitle}</strong>
              </LinkListTrustyleItem>
            </If>
          </section>
        </If>
        <ul
          sx={{
            padding: 0,
            listStyle: 'none',
            marginTop: '0',
          }}
        >
          {children}
        </ul>
      </div>
    </VariantContext.Provider>
  )
}

export const LinkListTrustyleItem = ({ children, href, className, icon }) => {
  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  const IconComponent = typeof icon === 'string' ? <DynamicSparkIcon glyph={icon} color='' /> : icon

  const variant = React.useContext(VariantContext)

  return (
    <li
      sx={{
        borderTop: '1px solid',
        borderTopColor: 'grey-20',
        paddingTop: 'xs',
        paddingBottom: 'xs',
        marginBottom: '0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        variant: styles(variant, 'li'),
      }}
      className={className}
    >
      <Themed.a
        href={href}
        sx={{
          textDecoration: 'none',
          borderBottom: 0,
          ':hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {children}
      </Themed.a>
      {IconComponent}
    </li>
  )
}
